import { render, staticRenderFns } from "./PptFooter.vue?vue&type=template&id=7051e058&"
import script from "./PptFooter.vue?vue&type=script&lang=js&"
export * from "./PptFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "pc/components/PptFooter.vue"
export default component.exports